/**
 * LegalCard — Steuernummer + Handelsregister.
 */
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { FileText } from 'lucide-react';

export const LegalCard = ({ formData, onChange }) => (
  <Card className="border-border/60">
    <CardHeader>
      <CardTitle className="font-heading flex items-center gap-2">
        <FileText className="h-5 w-5 text-primary" />
        Rechtliche Angaben
      </CardTitle>
    </CardHeader>
    <CardContent className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="tax_id">Steuernummer / USt-IdNr.</Label>
        <Input id="tax_id" value={formData.tax_id} onChange={(e) => onChange('tax_id', e.target.value)} placeholder="DE123456789" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="registration_number">Handelsregister</Label>
        <Input id="registration_number" value={formData.registration_number} onChange={(e) => onChange('registration_number', e.target.value)} placeholder="HRB 12345" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="managing_director">Geschäftsführer/in</Label>
        <Input id="managing_director" value={formData.managing_director} onChange={(e) => onChange('managing_director', e.target.value)} placeholder="Max Mustermann" data-testid="managing-director-input" />
      </div>
    </CardContent>
  </Card>
);
